/** Inputs are 40 px tall and 16 px text on touch screens (no iOS zoom), compact on desktop. */
export const CONTROL_CLASS = 'h-10 text-base md:h-9 md:text-sm';
